<ul>
  <li *ngFor="let similarItem of similarItems">
    <a class="link" (click)="onNavigate.emit(similarItem)">
      @if (relatedToType === relatedToTypeEnum.Project) {
        {{ similarItem.title }}
      } @else {
        {{ similarItem.name }}
      }
    </a>
  </li>
</ul>
